module.exports = __webpack_public_path__ + "img/weimeng-propa.10bc6c25.png";